import { FormControl, Box } from "@mui/material";
import styled from "styled-components";

export const StyledForm = styled(FormControl)`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  align-items: center;
`;

export const ButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  width: 100%;
`;
